import { render } from "./WAICreateView.vue?vue&type=template&id=0c395a5e&scoped=true"
import script from "./WAICreateView.vue?vue&type=script&lang=js"
export * from "./WAICreateView.vue?vue&type=script&lang=js"

import "./WAICreateView.vue?vue&type=style&index=0&id=0c395a5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c395a5e"]])

export default __exports__